import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import { CellsPickerModule } from './cells-picker/cells-picker.module';
import { CompaniesPickerModule } from './companies-picker/companies-picker.module';
import { ProjectsPickerModule } from './projects-picker/projects-picker.module';
import { UsersPickerModule } from './users-picker/users-picker.module';
import { FilterService } from './filter/filter.service';
import { SorterComponent } from './sorter/sorter.component';
import { SearchbarComponent } from './searchbar.component';
import { SearchbarHelpDialogComponent } from './searchbar-help-dialog.component';

@NgModule({
    imports: [
        CellsPickerModule,
        CommonModule,
        CompaniesPickerModule,
        FlexLayoutModule,
        MatButtonModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatCardModule,
        MatCheckboxModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatOptionModule,
        MatSelectModule,
        MatTooltipModule,
        ProjectsPickerModule,
        ReactiveFormsModule,
        UsersPickerModule
    ],
    declarations: [
        SearchbarComponent,
        SearchbarHelpDialogComponent,
        SorterComponent
    ],
    exports: [
        SearchbarComponent,
        SearchbarHelpDialogComponent,
        SorterComponent
    ],
    providers: [
        FilterService
    ]
})
export class SearchbarModule {
}
